/* METADATA */
export const GAME_NAME = "untemplate";

/* FUNCTIONAL CONFIGS */

/* UI CONFIGS */